export default {
  SET_HEADER_NAME (state, header_name) {
    state.header_name = header_name
  }
}
